import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

/**
 * Global footer with legal links + social. Shown on both public and authenticated pages.
 */
export function Footer({ compact = false }) {
  return (
    <footer
      className={`border-t border-slate-200 bg-white/60 ${compact ? "py-4" : "py-8 mt-10"}`}
      data-testid="app-footer"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {!compact && (
          <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6 mb-6">
            <div className="flex items-center gap-3">
              <img
                src="/branding/app_icon.png"
                alt="Ma Petite Yole"
                className="w-10 h-10 rounded-xl object-cover shadow-sm"
              />
              <div>
                <div className="brand-wordmark text-[color:var(--deep)] text-[18px] leading-none">
                  Ma Petite Yole
                </div>
                <div className="brand-signature text-[10px] mt-0.5">Prono. Vibré. Gagné.</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a
                href="mailto:contact@mapetiteyole.com"
                data-testid="footer-email"
                className="p-2 rounded-full text-slate-500 hover:bg-[color:var(--coral)]/10 hover:text-[color:var(--coral)] transition-colors"
                title="Nous écrire"
                aria-label="Email"
              >
                <Mail className="h-4 w-4" />
              </a>
              <a
                href="https://instagram.com/ma_petite_yole"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="p-2 rounded-full text-slate-500 hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white transition-colors"
                title="Instagram @ma_petite_yole"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>
        )}

        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-widest text-slate-500">
          <Link to="/cgu" data-testid="footer-cgu" className="hover:text-[color:var(--coral)] transition-colors">CGU</Link>
          <span className="text-slate-300">·</span>
          <Link to="/confidentialite" data-testid="footer-privacy" className="hover:text-[color:var(--coral)] transition-colors">Confidentialité</Link>
          <span className="text-slate-300">·</span>
          <Link to="/mentions-legales" data-testid="footer-legal" className="hover:text-[color:var(--coral)] transition-colors">Mentions légales</Link>
          <span className="text-slate-300">·</span>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-[color:var(--coral)] transition-colors">Contact</Link>
        </nav>

        <div className="text-center text-[10px] text-slate-400 mt-3 tracking-wide">
          © {new Date().getFullYear()} Fabien Deris EI · Ma Petite Yole
        </div>
      </div>
    </footer>
  );
}
